import { BadgeCircleComponent } from './badge-circle.component';

export default angular
  .module('sfMobile.components.badge-circle', [])
  .component('sfBadgeCircle', BadgeCircleComponent).name;
